var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-header"},[_c('div',{staticClass:"sub-header__wrap container flex"},[_c('h1',{staticClass:"sub-header__title main-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('button',{staticClass:"sub-header__button",on:{"click":function($event){return _vm.$router.go('-1')}}},[_vm._v("Назад")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }